// Apartment data for G21 Wiesbaden project
export const APARTMENTS = [
    {
        id: "erdgeschoss",
        name: "Erdgeschosswohnung",
        shortName: "EG",
        position: "Vorderhaus · Erdgeschoss",
        rooms: 3,
        size: "78,75",
        sizeUnit: "m²",
        priceLabel: "ca. 472.000 €",
        priceValue: 472000,
        parkingPrice: 29000,
        outdoor: "Terrasse",
        cellar: true,
        carport: true,
        accessible: true,
        tagline: "Komfortabel & barrierefrei",
        description:
            "Großzügig geschnittene 3-Zimmer-Wohnung mit barrierefreiem Zugang. Eigene Terrasse und privater Kellerraum sowie ein PKW-Carport im Hintergebäude.",
        highlights: [
            "Barrierefreier Zugang",
            "Private Terrasse",
            "Eigener Kellerraum",
            "PKW-Carport im Hintergebäude",
            "Fahrradständer im Innenhof",
            "Eigene Luft-Luft-Wärmepumpe",
            "PV-Anlage 2 kW inkl. Speicher",
            "Wallbox optional",
        ],
        image: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/55uiik9s_1000004118.jpg",
        floorplan: {
            level: "Erdgeschoss",
            totalSize: "78,75 m²",
            rooms: [
                { name: "Wohnen / Essen", size: "ca. 32,5 m²" },
                { name: "Schlafzimmer", size: "ca. 13,3 m²" },
                { name: "Arbeiten", size: "ca. 11,2 m²" },
                { name: "Küche", size: "ca. 9,1 m²" },
                { name: "Diele", size: "ca. 5,0 m²" },
                { name: "Badezimmer", size: "gefliest" },
            ],
            originalImage:
                "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/i7og39xy_image.png",
            note:
                "Detailgetreuer Grundriss aus den Bauunterlagen. Maße können bauseits geringfügig abweichen. Möblierung dient nur der Visualisierung.",
        },
    },
    {
        id: "obergeschoss",
        name: "Obergeschosswohnung",
        shortName: "OG",
        position: "Vorderhaus · Obergeschoss",
        rooms: 4,
        size: "116,86",
        sizeUnit: "m²",
        priceLabel: "ca. 783.000 €",
        priceValue: 783000,
        parkingPrice: 29000,
        outdoor: "Balkon",
        cellar: true,
        carport: true,
        accessible: false,
        tagline: "Familien-Highlight",
        description:
            "Familienfreundliche 4-Zimmer-Wohnung über eine Etage mit Balkon, Kellerraum und Carport. Hochwertige Ausstattung, Effizienzhaus 40.",
        highlights: [
            "4 großzügige Zimmer",
            "Privater Balkon",
            "Eigener Kellerraum",
            "PKW-Carport im Hintergebäude",
            "Fahrradständer im Innenhof",
            "Dreifachverglasung",
            "Eigene Luft-Luft-Wärmepumpe",
            "PV-Anlage 2 kW inkl. Speicher",
            "Wallbox optional",
        ],
        image: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/xpwqpso9_1000004274.jpg",
        floorplan: {
            level: "Obergeschoss",
            totalSize: "116,86 m²",
            rooms: [
                { name: "Wohnen / Essen", size: "ca. 28,3 m²" },
                { name: "Schlafzimmer", size: "ca. 16,0 m²" },
                { name: "Kinderzimmer (oben)", size: "ca. 14,0 m²" },
                { name: "Kinderzimmer (unten)", size: "ca. 14,5 m²" },
                { name: "Küche", size: "ca. 11,5 m²" },
                { name: "Bad (en-suite)", size: "ca. 5,0 m²" },
                { name: "Bad (Gäste)", size: "ca. 4,5 m²" },
                { name: "Diele / Flur", size: "ca. 5,0 m²" },
                { name: "Abstellraum", size: "ca. 2,5 m²" },
                { name: "Balkon", size: "ca. 4,5 m²" },
            ],
            originalImage:
                "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/m0onmsqy_image.png",
            note:
                "Detailgetreuer Grundriss aus den Bauunterlagen. Maße können bauseits geringfügig abweichen. Möblierung dient nur der Visualisierung.",
        },
    },
    {
        id: "penthouse",
        name: "Penthousewohnung",
        shortName: "PH",
        position: "Vorderhaus · Dachgeschoss",
        rooms: 3,
        size: "114,27",
        sizeUnit: "m²",
        priceLabel: "ca. 823.000 €",
        priceValue: 823000,
        parkingPrice: 29000,
        outdoor: "Dachterrasse",
        cellar: true,
        carport: true,
        accessible: false,
        tagline: "Penthaus-DG-Wohnung mit 18 m² Dachterrasse",
        description:
            "Penthousewohnung mit großzügiger Dachterrasse, klassischer Dachsilhouette und individuellem Schnitt. Lichtdurchflutete Räume mit hochwertigen Fenstern und moderner Gebäudetechnik.",
        highlights: [
            "Großzügige Dachterrasse",
            "Klassische Dachform mit Flachbereich",
            "Eigener Kellerraum",
            "PKW-Carport im Hintergebäude",
            "Fahrradständer im Innenhof",
            "PV-Anlage 2 kW inkl. Speicher",
            "Wallbox optional",
            "Optionaler Kaminanschluss",
        ],
        image: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/z8ehowlj_1000004277.jpg",
        floorplan: {
            level: "Dachgeschoss",
            totalSize: "114,27 m²",
            rooms: [
                { name: "Wohnen / Essen / Küche", size: "ca. 45,4 m²" },
                { name: "Schlafzimmer", size: "ca. 18,8 m²" },
                { name: "Arbeiten", size: "ca. 17,8 m²" },
                { name: "Badezimmer", size: "ca. 8,7 m²" },
                { name: "Flur / Diele", size: "ca. 6,7 m²" },
                { name: "Gäste-WC", size: "ca. 4,7 m²" },
                { name: "Dachterrasse", size: "18,13 m² (50 % angerechnet)" },
            ],
            originalImage:
                "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/rq5i6vbr_image.png",
            note:
                "Detailgetreuer Grundriss aus den Bauunterlagen. Maße können bauseits geringfügig abweichen. Die Dachterrasse hat 18,13 m² Fläche und wird gemäß Wohnflächenverordnung zu 50 % (9,07 m²) auf die Wohnfläche angerechnet. Möblierung dient nur der Visualisierung. Kaminanschluss optional.",
        },
    },
    {
        id: "loft-maisonette",
        name: "Hinterhaus-Maisonette · Loft",
        shortName: "LOFT",
        position: "Hinterhaus · Maisonette",
        rooms: 4,
        size: "116,62",
        sizeUnit: "m²",
        priceLabel: "ca. 723.000 €",
        priceValue: 723000,
        parkingPrice: 29000,
        outdoor: "Loggia + Dachterrasse",
        cellar: true,
        carport: true,
        accessible: false,
        tagline: "Urbanes Loft-Feeling",
        description:
            "Maisonette-Wohnung im Hinterhaus mit Loft-Charakter, Loggia und privater Dachterrasse. Ruhige Lage im Innenhof – ideal für entspanntes urbanes Wohnen.",
        highlights: [
            "Maisonette über zwei Ebenen",
            "Loggia + private Dachterrasse",
            "Loft-Charakter mit hohen Räumen",
            "Eigener Kellerraum",
            "PKW-Carport (EG Hintergebäude)",
            "Fahrradständer im Innenhof",
            "Eigene Luft-Luft-Wärmepumpe",
            "PV-Anlage 2 kW inkl. Speicher",
            "Wallbox optional",
        ],
        image: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/ol2ab3za_1000003624.jpg",
    },
];

export const HERO_IMAGE =
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/b57oc53l_1000004280.jpg";

export const VORDERHAUS_GALLERY = [
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/b57oc53l_1000004280.jpg",
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/55uiik9s_1000004118.jpg",
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/xpwqpso9_1000004274.jpg",
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/z8ehowlj_1000004277.jpg",
];

export const HINTERHAUS_GALLERY = [
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/ol2ab3za_1000003624.jpg",
    "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/h0oqp4m0_1000003618.jpg",
];

export const INTERIOR_GALLERY = [
    {
        url: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/j15xjzwh_1000004285.jpg",
        caption: "Wohnen mit Marmor-Kamin",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/edmledqr_1000004287.jpg",
        caption: "Offene Küche mit Wohnbereich",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/ntdnmj9c_1000003946.jpg",
        caption: "Loungebereich",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/o9dcy1ix_1000003960.jpg",
        caption: "Esszimmer mit Tageslicht",
    },
    {
        url: "https://customer-assets.emergentagent.com/job_gaugasse21-wiesbaden/artifacts/c4sx4ub5_1000003962.jpg",
        caption: "Schlafzimmer mit Akzentwand",
    },
];

export const LOCATION_IMAGE =
    "https://images.pexels.com/photos/13269288/pexels-photo-13269288.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";
